import React, { useState, useEffect } from 'react';
import { Button, Form, Container, Card, Row, Col, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';
import ServicesTable from './ServicesTable';
import { useApi } from './ApiContext';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

const ServicesPage = ({ token }) => {
  const [sDate, setStartDate] = useState('');
  const [eDate, setEndDate] = useState('');
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { baseUrl } = useApi();

  useEffect(() => {
    const today = new Date();
    const last7Days = new Date(today);
    last7Days.setDate(today.getDate() - 7);

    setStartDate(last7Days.toISOString().split('T')[0]);
    setEndDate(today.toISOString().split('T')[0]);

    fetchServices(last7Days.toISOString().split('T')[0], today.toISOString().split('T')[0]);
  }, []);

  const fetchServices = async (startDate, endDate) => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.post(
        `${baseUrl}/api/report/GetServicesbyDate`,
        { sDate: startDate, eDate: endDate },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setServices(response.data.data || []);
    } catch (err) {
      setError('Failed to fetch services. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleFetchServices = () => {
    fetchServices(sDate, eDate);
  };

  const handleFetchCurrentMonth = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 2).toISOString().split('T')[0];
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];
  
    setStartDate(firstDay);
    setEndDate(lastDay);
  
    fetchServices(firstDay, lastDay);
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, { html: '#services-table' });
    doc.save('services.pdf');
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(services);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Services');
    XLSX.writeFile(wb, 'services.xlsx');
  };

  return (
    <Container className="mt-5">
             <Card>
               <Card.Body>
                 <Card.Title>Services</Card.Title>
                 <Form>
                   {/* Date Input Row */}
                   <Row className="mb-3">
                     <Col md={6}>
                       <Form.Group>
                         <Form.Label>Start Date</Form.Label>
                         <Form.Control
                           type="date"
                           value={sDate}
                           onChange={(e) => setStartDate(e.target.value)}
                         />
                       </Form.Group>
                     </Col>
                     <Col md={6}>
                       <Form.Group>
                         <Form.Label>End Date</Form.Label>
                         <Form.Control
                           type="date"
                           value={eDate}
                           onChange={(e) => setEndDate(e.target.value)}
                         />
                       </Form.Group>
                     </Col>
                   </Row>
       
                   {/* Buttons Row */}
                   <Row>
                     <Col className="d-flex justify-content-end">
                       <Button className="me-2" onClick={handleFetchServices} disabled={loading}>
                         {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Fetch'}
                       </Button>
                       <Button variant="secondary" onClick={handleFetchCurrentMonth}>
                         Current Month
                       </Button>
                     </Col>
                   </Row>
                 </Form>
       
                 {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
               </Card.Body>
             </Card>

      <div className="d-flex justify-content-end mt-3">
        <Button className="me-2" onClick={exportToPDF}>
          Export to PDF
        </Button>
        <Button onClick={exportToExcel}>Export to Excel</Button>
      </div>

      <ServicesTable services={services} />
    </Container>
  );
};

export default ServicesPage;
